import { makeRequest, CommonRequestOptions } from './makeRequest';
import {
   EntityDisplayPermissions,
   PermissionLevel,
   PermissionObjectIdType,
   PermissionObjectType,
   PermissionPrivacyStatus,
} from '@dozuki/web-js/components';

export async function getPermissionLevels(
   objectType: PermissionObjectType,
   objectId: PermissionObjectIdType,
   options: CommonRequestOptions
): Promise<PermissionLevel[]> {
   return objectId
      ? await makeRequest('get', `permissions/${objectType}/subject/${objectId}`, options)
      : await makeRequest('get', `permissions/${objectType}/subject`, options);
}

export async function getPermissions(
   objectType: PermissionObjectType,
   objectid: PermissionObjectIdType,
   options: CommonRequestOptions
): Promise<EntityDisplayPermissions> {
   return await makeRequest('get', `permissions/${objectType}/entity/${objectid}`, options);
}

export async function setUserPermission(
   objectType: PermissionObjectType,
   objectId: PermissionObjectIdType,
   userids: number[],
   permissionLevel: PermissionLevel,
   options: CommonRequestOptions
): Promise<void> {
   return await makeRequest('put', `permissions/${objectType}/user/${objectId}`, {
      ...options,
      body: {
         userids,
         displayPermission: permissionLevel,
      },
   });
}

export async function setTeamPermission(
   objectType: PermissionObjectType,
   objectId: PermissionObjectIdType,
   teamids: number[],
   permissionLevel: PermissionLevel,
   options: CommonRequestOptions
): Promise<void> {
   return await makeRequest('put', `permissions/${objectType}/team/${objectId}`, {
      ...options,
      body: {
         teamids,
         displayPermission: permissionLevel,
      },
   });
}

export async function setPrivacyStatus(
   objectType: PermissionObjectType,
   objectId: PermissionObjectIdType,
   status: NonNullable<PermissionPrivacyStatus>,
   options: CommonRequestOptions
): Promise<void> {
   return await makeRequest('put', `permissions/${objectType}/privacy/${objectId}`, {
      ...options,
      body: {
         status,
      },
   });
}
